import type { FaireProductEntity } from "../../entity_types/product";

export const p_9bf3p6gtuv: FaireProductEntity = {
  token: "p_9bf3p6gtuv",
  type: "product",
  name: "Antep Pistachio Dessert Sauce 20% Turkish 300g",
  brandToken: "b_hms9dn67va",
  brandName: "Aladdin",
  imageUrl:
    "https://cdn.faire.com/fastly/22b565c8f21e0fe17ca46425d3a31f366fb03f4f5ab20de3058b7372f8294106.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/112f74b692d33f878dfde02d87d402c8a110d5d97baad4fcd1f4a27445dd89bf.webp",
    "https://cdn.faire.com/fastly/785f8ed88a4e5a1169f2206d3bf2f199ec3c4163db37b2006a35e6422b3cfcde.webp",
    "https://cdn.faire.com/fastly/554a0206ae3fb154c34458ad87cb506170bf634066597a3b6a424ed712fadd14.webp",
    "https://cdn.faire.com/fastly/354f8b4b3e42b837398f1f28e193036aff17bfd6f2495286a795fa5be9319f26.webp",
    "https://cdn.faire.com/fastly/c4e50495b8b900b270cda4f02f9265b93d1087438ca0a5b8877612f2f1e484c6.webp",
  ],
  priceDollars: 27.49,
  description:
    '"Authentic Gaziantep pistachio dessert sauce with 20% real Antep pistachios — the professional-grade topping trusted by Turkish pastry chefs and dessert bars.\n\n• Genuine Antep pistachio sourcing: terroir-specific flavor that artificial sauces cannot replicate\n• 20% pistachio content positions premium vs. budget 5% competitors on the same shelf\n• Ready-to-drizzle consistency: no prep, no dilution, direct-to-plate application\n• Strong upsell at POS alongside baklava, kunefe, and gourmet ice cream SKUs\n\n300g | Shelf life: 12 months | Ambient | Halal certified | Made in Turkey\nUpgrade your pastry program with the sauce that Turkish dessert chefs actually use."',
  tags: [],
  msrpDollars: 54.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:47:12.178Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
